import React from 'react'
import { MenuItem, type MenuItemProps } from '@chakra-ui/react'

import AssigneeInfo from './assignee-info'
import { UserBasicInfoFragment } from '~graphql/generated/graphql'

interface Props extends Omit<MenuItemProps, 'onSelect'> {
    user?: UserBasicInfoFragment
    onSelect: (user?: UserBasicInfoFragment) => void
}

export default function AssigneeItem({ user, onSelect, ...props }: Props) {
    return (
        <MenuItem
            onClick={() => onSelect(user)}
            py={1}
            borderLeftWidth={2}
            borderLeftColor="white"
            _focus={{
                borderLeftColor: 'brand.500',
                bg: 'gray.100',
            }}
            _active={{
                borderLeftColor: 'brand.500',
                bg: 'gray.100',
            }}
            _hover={{
                borderLeftColor: 'brand.500',
                bg: 'gray.100',
            }}
            {...props}
        >
            <AssigneeInfo user={user} />
        </MenuItem>
    )
}
